import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=5c336b4d&scoped=true&lang=pug&"
import script from "./TreeNode.vue?vue&type=script&lang=ts&"
export * from "./TreeNode.vue?vue&type=script&lang=ts&"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=5c336b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c336b4d",
  null
  
)

export default component.exports